import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createStatus = async (data) => {
      try {
        const response = await api.create(`/status/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getStatus = async () => {
      try {
        const response = await api.get(`/status/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateStatus = async ( id, data) => {
      try {
        const response = await api.put(`/status/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteStatus = async (id) => {
    try {
        const response = await api.delete(`/status/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
  
  export const getStatusByType = async (type) => {
    try {
        const response = await api.get(`/status/type/${type}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
